import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Alert from '@material-ui/lab/Alert';
import { Form, Formik } from 'formik';
import CustomInput from './components/CustomInput/CustomInput';
import * as yup from 'yup';
import axios from 'axios';

const formSchema = yup.object().shape({
  email: yup
    .string()
    .required('This field is required')
    .email('Please enter a valid email'),
  password: yup
    .string()
    .required('This field is required')
});

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '480px'
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const App = () => {
  const [token, setToken] = useState();
  const [backendError, setBackendError] = useState();
  const classes = useStyles();

  const registerUser = (values, { setSubmitting }) => {
    setToken(null);
    setBackendError(null);

    axios.post('/api/cards/register', JSON.stringify(values), {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => {
        setToken(res.data);
        setSubmitting(false);
      })
      .catch(err => {
        setBackendError(err.response.data);
        setSubmitting(false);
      });
  };

  return (
    <Container component='main' maxWidth='xs' className={classes.root}>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Registration
        </Typography>
        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={formSchema}
          onSubmit={registerUser}
        >
          {(formikProps) => (
            <Form onSubmit={formikProps.handleSubmit} noValidate className={classes.form}>
              <CustomInput
                type='text'
                required
                label='Email Address'
                name='email'
                autoComplete='email'
                autoFocus
              />
              <CustomInput
                type='password'
                required
                label='Password'
                name='password'
                autoComplete='current-password'
              />
              <Button
                type='submit'
                fullWidth
                variant='contained'
                color='primary'
                className={classes.submit}
                disabled={formikProps.isSubmitting}
              >
                Register
              </Button>
              <div>
                {token && <Alert severity="success">Your token is: <b>{token}</b></Alert>}
                {backendError && <Alert severity="error"><b>{backendError}</b></Alert>}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

export default App;
